import { BaseResponse } from 'domain/payload/response/BaseResponseDto';
import axiosInstance from '../../config/AxiosConfig'
import { ProjectMetricListResp } from 'domain/payload/response/clientTransmora/projectMetric/ProjectMetricListResp';
import { ProjectMetricDetailResp } from 'domain/payload/response/clientTransmora/projectMetric/ProjectMetricDetailResp';
import { ProjectMetricSaveReq } from 'domain/payload/request/clientTransmora/projectMetric/ProjectMetricSaveReq';

const ProjectMetricService = () => {
  const ProjectMetricList = async (
    token: string,
    search: string | null,
    page: number | null,
    size: number | null
  ): Promise<BaseResponse<ProjectMetricListResp[]>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/client-project-metric/list`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {
          search: search,
          page: page,
          size: size
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const ProjectMetricDetail = async (
    token: string,
    id: string
  ): Promise<BaseResponse<ProjectMetricDetailResp>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/client-project-metric/detail?id=${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const ProjectMetricSave = async (
    token: string,
    payload: ProjectMetricSaveReq
  ): Promise<BaseResponse<ProjectMetricDetailResp>> => {
    try {
      const response = await axiosInstance.post(`/v1/legacy/cms/client-project-metric/save`, payload, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const ProjectMetricDelete = async (
    token: string,
    id: string
  ): Promise<BaseResponse<any>> => {
    try {
      const response = await axiosInstance.delete(
        `/v1/legacy/cms/client-project-metric/delete`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: { id },
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  return { ProjectMetricList, ProjectMetricDetail, ProjectMetricSave, ProjectMetricDelete };
};

export default ProjectMetricService;